import React, { useState, useRef } from 'react';
import axios from 'axios';
import languageMap from '../languageMap';
import './imagesUploads.css';

const FileUpload = ({ username, eventName, upload_route, onUploadComplete }) => {
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [responseMessage, setResponseMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const selectedLanguage = languageMap.config.selectedLanguage || 'en';

  const handleFileSelection = () => {
    if (selectedFiles && selectedFiles.length > 0) {
      handleUpload(); // Proceed to upload if files are selected
    } else {
      fileInputRef.current.click(); // Trigger file selection dialog
    }
  };

  const handleFileChange = (event) => {
    setSelectedFiles(event.target.files);
    setResponseMessage(`${event.target.files.length} ${languageMap.selectedFiles[selectedLanguage]}`);
  };

  const handleUpload = async () => {
    if (!selectedFiles || selectedFiles.length === 0) return;
    setIsUploading(true);
    const formData = new FormData();
    Array.from(selectedFiles).forEach(file => {
      formData.append('files', file);
    });
    formData.append('user_id', username);
    formData.append('event_id', eventName);

    try {
      await axios.post(upload_route, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setResponseMessage(languageMap.uploadSuccessMessage[selectedLanguage]);
      if (onUploadComplete) onUploadComplete(true, 'FileUpload');
    } catch (error) {
      console.error('Error uploading files:', error);
      setResponseMessage(languageMap.uploadFailureMessage[selectedLanguage]);
      if (onUploadComplete) onUploadComplete(false, 'FileUpload');
    } finally {
      setIsUploading(false);
      setSelectedFiles(null); // Clear selection after upload
    }
  };

  return (
    <div className='file-upload'>
      <input
        type='file'
        multiple
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <button onClick={handleFileSelection} className='circular-button' disabled={isUploading}>
        {isUploading ?  selectedFiles.length > 0 && languageMap.uploadingButtonLabel[selectedLanguage] :
         selectedFiles ? languageMap.uploadingButtonLabel[selectedLanguage] :
         languageMap.selecteFiles[selectedLanguage]}
      </button>
      <div className='response'>
        {responseMessage && <p>{responseMessage}</p>}
      </div>
    </div>
  );
};

export default FileUpload;
